import React from 'react';

const TestApiCalls = ({ apiCalls, testId }) => {
  // Function to get the appropriate API calls content based on test ID
  const getApiCallsContent = () => {
    if (testId === 'vpc-flow-logs') {
      return `# Check if VPC Flow Logs are enabled for each VPC
ec2_client.describe_vpcs()
ec2_client.describe_flow_logs()`;
    } else if (testId === 'cloud-trail') {
      return `# Check if CloudTrail is enabled and properly configured
cloudtrail_client.describe_trails()
cloudtrail_client.get_trail_status()
cloudtrail_client.get_event_selectors()`;
    } else if (testId === 'multi-region-cloud-trail') {
      return `# Get all CloudTrail trails in the region
cloudtrail_client.describe_trails()

# Check if each trail is actively logging
cloudtrail_client.get_trail_status(
    Name=trail_name
)`;
    } else if (testId === 'vulnerability-scanning') {
      return `# Get all ECR repositories in the region
ecr_client.describe_repositories()

# Check scanning configuration for each repository
ecr_client.get_repository_scanning_configuration(
    repositoryName=repository_name
)`;
    } else if (testId === 'aws-inspector') {
      return `# Check if AWS Inspector is enabled
inspector_client.batch_get_account_status()

# Get scanning coverage statistics
inspector_client.get_coverage_statistics(
    filterCriteria={},
    groupBy='SCAN_STATUS'
)`;
    } else if (testId === 's3-server-access-logs') {
      return `# Check if S3 Server Access Logs are enabled for each bucket
s3_client.list_buckets()
s3_client.get_bucket_logging(Bucket=bucket_name)`;
    } else if (testId === 'log-retention') {
      return `# Check CloudWatch Log Groups for retention settings
logs_client.describe_log_groups()`;
    } else if (testId === 'mfa-root-account') {
      return `# Check if MFA is enabled on the root AWS account
iam_client.get_account_summary()`;
    } else if (testId === 'iam-user-policies') {
      return `# Get all IAM users
iam_client.list_users()

# Check for attached managed policies for each user
iam_client.list_attached_user_policies(
    UserName=user_name
)

# Check for inline policies for each user
iam_client.list_user_policies(
    UserName=user_name
)`;
    } else if (testId === 's3-bucket-encryption') {
      return `# Get all S3 buckets
s3_client.list_buckets()

# Check encryption configuration for each bucket
s3_client.get_bucket_encryption(
    Bucket=bucket_name
)`;
    } else if (testId === 'dynamodb-encryption') {
      return `# Get all DynamoDB tables in the region
dynamodb_client.list_tables()

# Check encryption settings for each table
dynamodb_client.describe_table(
    TableName=table_name
)`;
    } else if (testId === 'guard-duty') {
      return `# Check if any GuardDuty detectors exist
guardduty_client.list_detectors()

# Get details about each GuardDuty detector
guardduty_client.get_detector(
    DetectorId=detector_id
)`;
    } else if (testId === 'security-hub') {
      return `# Check if Security Hub is enabled in the region
security_hub_client.describe_hub()`;
    } else {
      return apiCalls.join('\n');
    }
  };

  return (
    <div className="p-4 border-t border-gray-200">
      <h3 className="text-lg font-medium mb-3">API Calls</h3>
      <pre className="whitespace-pre-wrap bg-gray-50 p-3 rounded-md text-sm font-mono text-gray-700 overflow-auto max-h-60">
        {getApiCallsContent()}
      </pre>
    </div>
  );
};

export default TestApiCalls;
